import {
  createSlice,
  createSelector,
  PayloadAction,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import {
  resetSnack,
  successSnack,
  errorSnack,
} from "../snackbar/snackbarSlice";

import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

export const fetchUserPoints = createAsyncThunk(
  "userpoints/fetchUserPoints",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/clients/${args.clientID}/user_points${args.query}`,
        config
      );
      thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(setUserPointsAmount(response.headers["x-total-count"]));
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching UserPoints list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchMoreUserPoints = createAsyncThunk(
  "userpoints/fetchMoreUserPoints",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/clients/${args.clientID}/users${args.query}&offset=${args.offset}`,
        config
      );

      // thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(setUserPointsAmount(response.headers["x-total-count"]));

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
      }
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(
        //   errorSnack(
        //     error.response.data.error_description ||
        //       'Error fetching products list'
        //   )
        // );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const getFullList = createAsyncThunk(
  "products/getFullList",
  async (args, thunkAPI) => {
    let objToMap = [];
    for (let i = 0; i < (args.targetLength - args.offset) / 100; i++) {
      objToMap.push({
        token: args.token,
        query: args.query,
        offset: args.offset + 100 * i,
      });
    }

    Promise.all(
      objToMap.map((requestData) =>
        thunkAPI.dispatch(fetchMoreUserPoints(requestData))
      )
    )
      .then((results) => {})
      .catch((err) => {
        return thunkAPI.rejectWithValue("Error fetching full product list");
      });
  }
);

const userPointsSlice = createSlice({
  name: "userPoints",
  initialState: {
    userPointsList: [],
    loading: "idle",
    error: "",
    userPointsAmount: "",
    lastQuery: "",
  },
  reducers: {
    setLastQuery: (state, action) => {
      state.lastQuery = action.payload;
    },
    setUserPointsAmount: (state, action) => {
      state.userPointsAmount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserPoints.pending, (state) => {
      state.userPointsList = [];

      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchUserPoints.fulfilled, (state, { payload }) => {
      state.userPointsList = payload;

      state.loading = "loaded";
      state.editing = false;
    });
    builder.addCase(fetchUserPoints.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchMoreUserPoints.fulfilled, (state, { payload }) => {
      state.error = "";
      state.userPointsList = state.userPointsList.concat(payload);
      state.loading = "loaded";
    });
    builder.addCase(fetchMoreUserPoints.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(getFullList.fulfilled, (state, { payload }) => {
      state.error = "";
      state.userPointsList = state.userPointsList.sort(function (a, b) {
        return a.id - b.id;
      });
      state.loading = "loaded";
    });
    builder.addCase(getFullList.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
  },
});

export const { setLastQuery, setUserPointsAmount } = userPointsSlice.actions;

export const selectUserPoints = createSelector(
  (state) => ({
    userPointsList: state.userPoints.userPointsList,
    loading: state.userPoints.loading,
    error: state.userPoints.error,
    userPointsAmount: state.userPoints.userPointsAmount,
    lastQuery: state.userPoints.lastQuery,
  }),
  (state) => state
);
export default userPointsSlice.reducer;
